import { Formik, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { productPlanningCreateAction } from "../../redux/actions/product-action";
import AddButton from "../buttons/button";
import InputField from "../forms/input-field";
import successToast from "../helper-components/success-toast";
import errorToast from "../helper-components/error-toast";

const PlanningTab = ({
  productId,
  setFormValues,
  formValues,
  setCurrentTab,
  product,
  disabled = false,
  itemGeneralData = {},
  onTabChange,
}) => {
  const dispatch = useDispatch();

  // Planning tab specific state for navigation blocking
  const [planningHasUnsavedChanges, setPlanningHasUnsavedChanges] =
    useState(false);
  const [planningIsFormSaved, setPlanningIsFormSaved] = useState(false);
  const initialValues = {
    item_id: product?.item_id ?? productId,
    item_order_interval: product?.item_order_interval ?? null,
    item_order_multiple: product?.item_order_multiple ?? null,
    item_minimum_order_quantity: product?.item_minimum_order_quantity ?? null,
    item_checking_rule: product?.item_checking_rule ?? "",
  };
  const validationSchema = Yup.object().shape({});

  // Planning tab change tracker and navigation blocking
  const FormChangeTracker = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      // Don't track changes if form was just saved
      if (planningIsFormSaved) {
        setPlanningHasUnsavedChanges(false);
        if (onTabChange) {
          onTabChange(false);
        }
        return;
      }

      // Compare with initial values
      const hasChanges =
        JSON.stringify(initialValues) !== JSON.stringify(values);
      setPlanningHasUnsavedChanges(hasChanges);

      // Notify parent component about changes
      if (onTabChange) {
        onTabChange(hasChanges);
      }

      console.log("=== PLANNING TAB CHANGE TRACKER ===");
      console.log("Planning has changes:", hasChanges);
      console.log("Initial values:", initialValues);
      console.log("Current values:", values);
    }, [values, planningIsFormSaved, onTabChange]);

    // Navigation blocking is now handled by parent component (EditProduct)

    return null;
  };

  const innerOnSubmit = (values) => {
    if (JSON.stringify(initialValues) === JSON.stringify(values)) {
      return errorToast("No changes");
    }
    setFormValues({
      ...formValues,
      planning: values,
    });

    // Reset planning form state after successful submission
    setPlanningHasUnsavedChanges(false);
    setPlanningIsFormSaved(true);
    dispatch(
      productPlanningCreateAction(
        {
          itemGeneralData: itemGeneralData,
          itemPlanningData: values,
        },
        onSuccess,
        onError
      )
    );
  };

  const onSuccess = (data) => {
    successToast(data?.message);
    setCurrentTab("Discounts & Scheme");
  };
  const onError = (data) => { };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={formValues?.planning ?? initialValues}
        validationSchema={validationSchema}
        onSubmit={innerOnSubmit}
      >
        {({ values, handleSubmit, errors }) => {
          return (
            <>
              <FormChangeTracker />
              <div className="flex flex-wrap mt-3">
                <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10">
                  <InputField
                    isDisabled={disabled}
                    type="number"
                    name="item_order_interval"
                    placeholder="Enter Order Interval"
                    label="Order Interval"
                    isRequired={false}
                    labelWidth="9rem"
                  />

                  <InputField
                    isDisabled={disabled}
                    type="number"
                    name="item_order_multiple"
                    placeholder="Enter Order Multiple"
                    label="Order Multiple"
                    isRequired={false}
                    labelWidth="9rem"
                  />
                </div>
                <div className="w-full 2xl:w-[35%] lg:w-1/2 px-5 xl:px-10 mt-10 lg:mt-0">
                  <InputField
                    isDisabled={disabled}
                    type="number"
                    name="item_minimum_order_quantity"
                    placeholder="Enter Minimum Order Qty"
                    label="Minimum Order Qty"
                    isRequired={false}
                    labelWidth="9rem"
                  />
                  <InputField
                    isDisabled={disabled}
                    type="number"
                    name="item_checking_rule"
                    placeholder="Add Checking Rule"
                    label="Checking Rule"
                    isRequired={false}
                    labelWidth="9rem"
                  />
                </div>
              </div>
              {!disabled && (
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    onclkFn={handleSubmit}
                    prefixIcon={false}
                    text="Save"
                    type="submit"
                  />
                </div>
              )}
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default PlanningTab;
